import { parseReportKey } from "Utils";

export type ReportIdentifiers = {
  groupId: string;
  projectName: string;
  packageName?: string;
  version?: string;
};

export const belongsToProjectPackageOrVersion = (
  reportKey: string,
  { groupId, projectName, packageName, version }: ReportIdentifiers,
): boolean => {
  const {
    groupId: reportGroup,
    projectName: reportProject,
    packageName: reportPackage,
    version: reportVersion,
  } = parseReportKey(reportKey);

  if (groupId !== reportGroup) return false;

  if (version) {
    return (
      reportProject === projectName &&
      reportPackage === packageName &&
      reportVersion === version
    );
  } else if (packageName) {
    return reportProject === projectName && reportPackage === packageName;
  } else {
    return reportProject === projectName;
  }
};
